import { requireAuth } from '@/router/helpers';

// The following routes are for '/documents' (Forms & Policies)

export default [
  // Documents -> Default
  {
    path: '/documents/:docType',
    name: 'Documents',
    component: () => import('@/views/Documents'),
    beforeEnter: requireAuth,
    // redirect: { name: 'Dashboard' },
  },

  {
    path: '/documents/:docType/create',
    name: 'DocumentCreate',
    components: {
      default: () => import('@/views/Documents'),
      panel: () => import('@/views/documents/DocumentCreate'),
    },
    beforeEnter: requireAuth,
    props: { default: true, panel: false },
    // redirect: { name: 'Dashboard' },
    meta: {
      openPanel: true,
      isAdmin: false,
      // permissions: [`add_${this.docType}`],
    },
  },

  // Documents -> Default
  {
    path: '/documents/:docType/:tab',
    name: 'DocumentTabs',
    component: () => import('@/views/Documents'),
    beforeEnter: requireAuth,
    // redirect: { name: 'Dashboard' },
    meta: { myDocsOpen: true },
  },

  // Document -> Preview
  {
    path: '/documents/:docType/:id',
    name: 'DocumentPreview',
    // redirect: { name: 'Dashboard' },
    components: {
      default: () => import('@/views/Documents'),
      panel: () => import('@/views/documents/DocumentPreview'),
    },
    beforeEnter: requireAuth,
    
    meta: {
      openPanel: true,
    },
  },

  {
    path: '/documents/:docType/:id/version/:versionId',
    name: 'DocumentVersionPreview',
    components: {
      default: () => import('@/views/Documents'),
      panel: () => import('@/views/documents/DocumentPreview'),
    },
    beforeEnter: requireAuth,
    // redirect: { name: 'Dashboard' },
    meta: {
      openPanel: true,
    },
  },
];
